module.exports = __webpack_public_path__ + "media/images/icons/icon-dialog-cbe1e3359b6eac96e5c82986c7418e77.svg";